export const RENTAL_FEE_ACCOUNTS_TAB_ID = 'ACCOUNTS'
export const RENTAL_FEE_SERVICES_TAB_ID = 'SERVICES'
